export const DEFAULT_SCHEDULED_TYPE = 'WPP_DUPLICATE_BILLING_2_ASSIGNOR'; //TODO remover isso aqui no futuro

export enum BucketType {
    DISBURSEMENT_RECEIPT = "DISBURSEMENT_RECEIPT",
    BOLETO = "BOLETO",
    BOLETO_IMAGE = "BOLETO-IMAGE",
}

export const BUCKETS = {
    [BucketType.BOLETO]: "agrolend-s3-boleto",
    [BucketType.BOLETO_IMAGE]: "agrolend-s3-boleto-pdf-converted",
    [BucketType.DISBURSEMENT_RECEIPT]: "agrolend-s3-receipt",
};